import styled from "styled-components";
import moment from "moment-jalaali";

export default function OrderDetails({ data, user }) {
  return (
    <List>
      <Item>
        <div className="title">کد سفارش</div>
        <div className="value">{data.id}</div>
      </Item>
      <Item>
        <div className="title">مبلغ پرداختی</div>
        <div className="value">
          {(Number(data.order_price) / 10).toLocaleString()} تومان
        </div>
      </Item>
      {data.coupon ? (
        <Item>
          <div className="title">کد تخفیف</div>
          <div className="value">{data.coupon}</div>
        </Item>
      ) : null}
      <Item>
        <div className="title">کد پرداخت</div>
        <a
          href={`https://next.zarinpal.com/panel/epet.co/session/${data.payment_id}`}
          target="_blank"
          rel="noreferrer"
          className="value"
        >
          {data.payment_id}
        </a>
      </Item>
      <Item>
        <div className="title">تاریخ تایید سفارش</div>
        <div className="value">
          {moment(data.updated_at).format("jYYYY/jM/jD HH:mm:ss")}
        </div>
      </Item>
      <h3>اطلاعات ارسال</h3>
      {data.shipment_id ? (
        <Item className="active">
          <div className="title">کد رهگیری پستی</div>
          <div className="value">{data.shipment_id}</div>
        </Item>
      ) : null}
      <Item>
        <div className="title">آدرس پستی</div>
        <div className="value">
          {JSON.parse(data.shipment_address).province} -{" "}
          {JSON.parse(data.shipment_address).city} -{" "}
          {JSON.parse(data.shipment_address).address}
        </div>
      </Item>
      <Item>
        <div className="title">کد پستی</div>
        <div className="value">{JSON.parse(data.shipment_address)?.postal}</div>
      </Item>
      <Item>
        <div className="title">نام مشتری</div>
        <div className="value">{user?.name}</div>
      </Item>{" "}
      <Item>
        <div className="title">تلفن مشتری</div>
        <div className="value">{user?.phone}</div>
      </Item>
      <Item>
        <div className="title">نوع ارسال</div>
        <div className="value">
          {data.shipment_type === "1"
            ? "پست"
            : data.shipment_type === "2"
            ? "تیپاکس"
            : "باربری"}
        </div>
      </Item>
      <Item>
        <div className="title">هزینه ارسال</div>
        <div className="value">
          {Number(data.shipment_price).toLocaleString()} تومان
        </div>
      </Item>
      <h3>محصولات</h3>
      {JSON.parse(data.products)?.map((product, key) => (
        <Item key={key}>
          <div className="title">{product.data.title}</div>
          <div className="value">
            {product.data.isOff
              ? Number(product.data.off_price).toLocaleString()
              : Number(product.data.price).toLocaleString()}
            تومان
          </div>
          <div className="amount">{product.amount} عدد</div>
        </Item>
      ))}
      <h3>مالی</h3>
      <Item>
        <div className="title">محصولات</div>
        <div className="value">
          {Number(
            JSON.parse(data.products).reduce(
              (prev, next) => prev + Number(next.data.price) * next.amount,
              0
            )
          ).toLocaleString()}{" "}
          تومان
        </div>
      </Item>
      <Item>
        <div className="title">تخفیف</div>
        <div className="value">
          {data?.coupon_off
            ? `- ${Number(data.coupon_off).toLocaleString()}`
            : 0}{" "}
          تومان
        </div>
      </Item>
      <Item style={{ borderBottom: "1px solid #222" }}>
        <div className="title">هزینه ارسال</div>
        <div className="value">
          {Number(data.shipment_price).toLocaleString()} تومان
        </div>
      </Item>
      <Item>
        <div className="title">مبلغ پرداختی</div>
        <div className="value">
          {(Number(data.order_price) / 10).toLocaleString()} تومان
        </div>
      </Item>
    </List>
  );
}
const List = styled.div`
  & h3 {
    font-weight: bold;
    margin: 24px 0 9px 0;
  }
`;
const Item = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 10px 0;
  margin-bottom: 10px;
  border-bottom: 1px solid #c6c6c6;
  &.active {
    color: #36a836;
  }
  .title {
    width: 140px;
    margin-left: 16px;
    border-left: 1px solid #c6c6c6;
  }
  .amount {
    width: 80px;
    padding-right: 16px;
    margin-right: 16px;
    border-right: 1px solid #c6c6c6;
  }
`;
